// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// constant imports
import { URLConstants } from '../../_constants/url-constants';
import { WFEAccountantStepEditorResultDto } from '../_models/workflow-accountant-step/wfe-accountant-step-editor-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class WorkflowAccountantStepService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getWorflowAccountantStepEditor(baseParams) {
        baseParams.clearCache = true;
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}acct/editor${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(WFEAccountantStepEditorResultDto, response)));
    }
    approve(baseParams) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/approve`, classToPlain(baseParams));
    }
    createBillAndHold(baseParam) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/hold`, classToPlain(baseParam));
    }
    denyToCAM(baseParam) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/deny/cam`, classToPlain(baseParam));
    }
    denyToAAP(baseParam) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/deny/aap`, classToPlain(baseParam));
    }
    updateInInbox(baseParam) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/inbox`, classToPlain(baseParam));
    }
    updateInReview(baseParam) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/review`, classToPlain(baseParam));
    }
    denyReturnToCAM(baseParam, action) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/${action}-bill/cam`, classToPlain(baseParam));
    }
    denyReturnToAAP(baseParam, action) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/${action}-bill/aap`, classToPlain(baseParam));
    }
    deniedCompleteWorkflow(baseParam, action) {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}acct/${action}-bill`, classToPlain(baseParam));
    }
}
WorkflowAccountantStepService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WorkflowAccountantStepService_Factory() { return new WorkflowAccountantStepService(i0.ɵɵinject(i1.HttpClient)); }, token: WorkflowAccountantStepService, providedIn: "root" });
